
/**
 * Compactly formats a number:
 * - Below 1,000: unchanged (e.g., 892)
 * - 1,000–999,999: X.XK (rounded, e.g., 1,456 → "1.5K")
 * - 1,000,000–999,999,999: X.XM (e.g., 2,350,000 → "2.4M")
 * - 1,000,000,000+: X.XB
 */
export const formatCompactNumber = (num: number): string => {
  if (isNaN(num)) return "";
  if (Math.abs(num) < 1000) return num.toString();
  if (Math.abs(num) < 1_000_000) {
    const val = Math.round((num / 1_000) * 10) / 10;
    return `${val}${val % 1 ? "" : ""}K`;
  }
  if (Math.abs(num) < 1_000_000_000) {
    const val = Math.round((num / 1_000_000) * 10) / 10;
    return `${val}${val % 1 ? "" : ""}M`;
  }
  const val = Math.round((num / 1_000_000_000) * 10) / 10;
  return `${val}${val % 1 ? "" : ""}B`;
};
